import AOS from 'aos';

import './utils/vh.utils.js';
import './utils/animate-on-view.utils';
import './utils/meta.utils.js';

import './components/meta/select.component.js';
import './components/meta/btn-upload.component.js';
import './components/project-dropdown.component.js';

import './components/marquee/_index.js';
import './components/swiper/_index.js';
import './components/cards/_index.js';
import './components/sections/_index.js';
import './components/animations/_index.js';

import './components/validation.component.js';

import './components/uploadFile.component.js';
import './components/header.component.js';
import './components/inputs.component.js';
import './components/animations.component.js';
import './components/player.component.js';
import './components/search-sec.component.js';

import './libs/countUp.lib.js';
import './libs/smoothScrollbar.lib.js';


AOS.init({
  offset: 50,
  delay: 10,
  duration: 600,
  easing: 'ease-in-out',
  once: true,
  startEvent: 'DOMContentLoaded',
});


const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if(isSafari) document.body.classList.add('is-safari');